<template>
  <div>
    <div class="primary font-semibold pb-3">
      Order Details
    </div>
    <div class="flex">
      <div class="pr-4 text-sm text-gray-400 ">
        <div>Type</div>
        <div>Status</div>
        <div>Price</div>
        <div>Term</div>
        <div>Total Paid</div>
        <div>Current Balance</div>
        <div>Checkout</div>
      </div>
      <div class="text-sm primary font-semibold">
        <div>{{ origin || 'N/A' }}</div>
        <div>{{ status || 'N/A' }}</div>
        <div>{{ currency }} {{ amount }}</div>
        <div>{{ term || 'N/A' }}</div>
        <div>{{ currency }} {{ totalPaid }}</div>
        <div>{{ currency }} {{ totalOwing }}</div>
        <div>{{ checkoutName || 'N/A' }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">

interface Props {
  origin: string;
  status: string;
  amount: string;
  term: number;
  totalPaid: string;
  totalOwing: string;
  checkoutName: string;
  currency: string;
}

defineProps<Props>();
</script>
